import { Offcanvas } from 'react-bootstrap';

const ViewHistoryOffcanvas = ({
    show,
    onHide
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Workflow History</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='p-4'>
                <div>
                    {[
                        { date: '14 Aug 2025', time: '10:30 AM', user: 'John Doe', action: 'Created tasklist "Website Development Phase 1"' },
                        { date: '14 Aug 2025', time: '11:15 AM', user: 'Sarah Smith', action: 'Added new workflow "Design Review"' },
                        { date: '14 Aug 2025', time: '02:00 PM', user: 'Mike Johnson', action: 'Assigned tasklist to Design Team' },
                        { date: '13 Aug 2025', time: '09:45 AM', user: 'Emily Brown', action: 'Updated tasklist description' },
                        { date: '13 Aug 2025', time: '03:30 PM', user: 'David Wilson', action: 'Changed workflow to "In Progress"' },
                        { date: '12 Aug 2025', time: '11:00 AM', user: 'Lisa Anderson', action: 'Added new assignee "Robert Taylor"' },
                        { date: '12 Aug 2025', time: '02:45 PM', user: 'Robert Taylor', action: 'Updated tasklist status' },
                        { date: '11 Aug 2025', time: '10:00 AM', user: 'John Doe', action: 'Modified workflow settings' },
                        { date: '11 Aug 2025', time: '04:15 PM', user: 'Sarah Smith', action: 'Removed assignee "Mike Johnson"' },
                        { date: '10 Aug 2025', time: '01:30 PM', user: 'Emily Brown', action: 'Changed tasklist name to "Website Dev Phase 1"' }
                    ].map((item, index) => (
                        <div key={index} className='border p-3 rounded-3 mb-3'>
                            <div className='p-tag fs-12'>
                                {item.date} at {item.time}
                            </div>
                            <div className='p-tag fw-bold border-bottom pb-2'>{item.user}</div>
                            <div className='p-tag mt-2'>{item.action}</div>
                        </div>
                    ))}
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ViewHistoryOffcanvas;
